import React from 'react';
import {
  Box,
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Text,
} from '@razorpay/blade/components';

interface DisableAttendanceModalProps {
  isOpen: boolean;
  onKeepEnabled: () => void;
  onDisable: () => void;
}

export const DisableAttendanceModal = ({
  isOpen,
  onKeepEnabled,
  onDisable,
}: DisableAttendanceModalProps) => {
  return (
    <Modal isOpen={isOpen} onDismiss={onKeepEnabled}>
      <ModalHeader title="Disable Time & Attendance" />
      <ModalBody>
        <Box display="flex" flexDirection="column" gap="spacing.4">
          <Text size="medium" color="surface.text.gray.muted">
            Your team will no longer be able to mark attendance, apply for leaves, or accrue new
            leave balances.
          </Text>
          <Text size="medium" color="surface.text.gray.muted">
            Existing balances and historical records will be preserved. You can re-enable T&amp;A
            any time.
          </Text>
          <Text size="medium" color="surface.text.gray.muted">
            Any in-progress payroll cycles will not be affected.
          </Text>
        </Box>
      </ModalBody>
      <ModalFooter>
        <Box display="flex" gap="spacing.3" justifyContent="flex-end" width="100%">
          <Button variant="secondary" onClick={onKeepEnabled}>
            Keep Enabled
          </Button>
          <Button variant="primary" color="negative" onClick={onDisable}>
            Disable
          </Button>
        </Box>
      </ModalFooter>
    </Modal>
  );
};
